import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/data';

export default function Footer() {
  const { t } = useTranslation();

  const footerCategories = categories.slice(0, 4);

  return (
    <footer className="bg-foreground-900 text-background-50" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading whitespace-nowrap">{t('footer.brand')}</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-medium mb-4 text-background-50">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.home')}</Link></li>
              <li><Link to="/category/hot" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.category')}</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.about')}</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.vip')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-medium mb-4 text-background-50">{t('footer.categories')}</h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-medium mb-4 text-background-50">{t('footer.contact')}</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{t('footer.email')}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-primary-400"></i>
                <span>{t('footer.phone')}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>{t('footer.address')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">{t('footer.copyright')}</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors" aria-label="微信">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-wechat-line"></i></div>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors" aria-label="微博">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-weibo-line"></i></div>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors" aria-label="B站">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-bilibili-line"></i></div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}